export enum Language {
  DE = 'de',
  EN = 'en',
  ES = 'es',
  CA = 'ca',
}

export const DEFAULT_LANGUAGE = Language.EN

export const LANGUAGES = Object.values(Language)

export const langToLocale: Record<Language, string> = {
  [Language.DE]: 'de_DE',
  [Language.EN]: 'en_US',
  [Language.ES]: 'es_ES',
  [Language.CA]: 'ca_ES',
}

export const langToHtml: Record<Language, string> = {
  [Language.DE]: 'de',
  [Language.EN]: 'en',
  [Language.ES]: 'es',
  [Language.CA]: 'ca',
}

export const langToLabel: Record<Language, string> = {
  [Language.DE]: 'DE',
  [Language.EN]: 'EN',
  [Language.ES]: 'ES',
  [Language.CA]: 'CA',
}
